import { Empty } from 'antd'
import { useEffect, useState } from 'react'

import Loading from '@/components/Loading'
import { useGroupId } from '@/hooks/group'
import { actions, useDispatch, useSelector } from '@/redux'

export default function CRMDataLoader({ children }) {
  const dispatch = useDispatch()
  const { accountsVersion, crmGroups } = useSelector((state) => state.merchant)
  const groupId = useGroupId()
  const [loadedAccountsVersion, setLoadedAccountsVersion] = useState(null)

  useEffect(() => {
    let mounted = true
    dispatch(actions.merchant.fetchCRMGroups())
      .catch((error) => console.error('load CRM error', error))
      .finally(() => {
        if (mounted) setLoadedAccountsVersion(accountsVersion)
      })
    return () => {
      mounted = false
    }
  }, [dispatch, accountsVersion])

  if (loadedAccountsVersion !== accountsVersion) return <Loading />
  if (!Object.keys(crmGroups).length || (groupId && !crmGroups[groupId])) return <Empty />
  return children
}
